import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CreateCustomer from "./CreateIndividualCustomer";
import CustomerDetails from './IndividualCustomerDetails';
import CustomerList from "./IndividualCustomerList";
import EditCustomerDetails from "./EditIndividualCustomer";
import CreateIndividualuserinfo from "./CreateIndividualuserinfo";
import CreateIndividualuserinfoagg from "./CreateIndividualuserinfoagg";

export default function IndividualCustomer() {
  return (
    <Switch>
      <Redirect exact={true} from="/indiv-customer" to="/indiv-customer/customer-list" />

      {/* Layout */}
      <Route exact={true} path="/indiv-customer/customer-list" component={CustomerList} />
      <Route exact={true} path="/indiv-customer/customer-details" component={CustomerDetails} />
      <Route exact={true} path="/indiv-customer/customer-create" component={CreateCustomer} />
      <Route exact={true} path="/indiv-customer/customer-edit" component={EditCustomerDetails} />
      <Route exact={true} path="/indiv-customer/customer-create-user" component={CreateIndividualuserinfo} />
	  <Route exact={true} path="/indiv-customer/customer-create-useragg/:params" component={CreateIndividualuserinfoagg} />
    </Switch>
  );
}
